import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  updateUserRole: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}
}
